import React, { Fragment, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Card, Tab, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUsers, 
    faUserShield, 
    faUserTag, 
    faBars, 
    faCog,
    faUsersCog
} from '@fortawesome/free-solid-svg-icons';
import Menu from './Menu';
import Role from './Role';
import Profil from './Profil';
import User from './User';
import Action from './Action';
import MenuRoleAction from './MenuRoleAction';
import { useTranslation } from "react-i18next";
import { getUsersAction, getUserParameterAction, getActionsAction, getRolesAction, getMenusAction } from '../../../store/actions/UserAction';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";

const UserProfil = (props) => {
    const { t } = useTranslation();
    let errorsObj = { name: '', code: '' };
    const dispatch = useDispatch();
    const header = ["Nom", "code", "Date de création", "Action"];

    useEffect(() => {
        dispatch(getUsersAction());    
        dispatch(getUserParameterAction());  
        dispatch(getActionsAction());    
        dispatch(getRolesAction());    
        dispatch(getMenusAction());  
    }, []);

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if (!theMenu) {
            return false;
        } else {
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    // Tab data with FontAwesome icons
    const tabData = [
        {
            label: t("User"),
            name: 'user',
            icon: faUsers,
            content: <User />
        },
        {
            label: t("Profil"),
            name: 'profil',
            icon: faUserShield,
            content: <Profil />
        },
        {
            label: t("Role"),
            name: 'role',
            icon: faUserTag,
            content: <Role />
        },
        {
            label: t("Menu"),
            name: 'menu',
            icon: faBars,
            content: <Menu />
        },
        {
            label: t("Action"),
            name: 'action',
            icon: faCog,
            content: <Action />
        },
        /*{
            label: t("MenuRoleAction"),
            name: 'menuroleaction',
            icon: faUsersCog,
            content: <MenuRoleAction />
        },*/
    ];

    const hasAccess = (type) => {
        switch (type) {
            case 'user':
                return hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'LISTUSER');
            case 'profil':
                return hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'LISTPROFIL');
            case 'role':
                return hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'LISTROLE');
            case 'menu':
                return hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'LISTMENU');
            case 'action':
                return hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'LISTACTION');
            default:
                return false;
        }
    }

    return (
        <Fragment>
            <Row>
                <Col xl={12}>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0 pb-0">
                            <div>
                                <Card.Title className="mb-1 h4">
                                    <FontAwesomeIcon icon={faUsersCog} className="text-primary me-2" />
                                    {t('user.parameter')}
                                </Card.Title>
                                <p className="text-muted mb-0 small">{t("common.manage-user-parameters")}</p>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0 pt-0">
                            {/* Clean Nav tabs without borders */}
                            <div className='custom-tab-1'>
                                <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                                    <Nav as='ul' className='nav-tabs bg-white px-3 pt-2' style={{ border: 'none' }}>
                                        {tabData.map((data, i) => (
                                            <Nav.Item as='li' key={i} className="me-1">
                                                <Nav.Link 
                                                    disabled={!hasAccess(data.name.toLowerCase())} 
                                                    eventKey={data.name.toLowerCase()}
                                                    className={`px-3 py-2 ${
                                                        !hasAccess(data.name.toLowerCase()) 
                                                            ? 'text-muted' 
                                                            : 'text-primary'
                                                    }`}
                                                    style={{ 
                                                        border: 'none',
                                                        background: 'transparent',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={data.icon} className="me-2" />
                                                        <span className="fw-medium">{data.label}</span>
                                                    </div>
                                                </Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                    <Tab.Content className='bg-white'>
                                        {tabData.map((data, i) => (
                                            <Tab.Pane eventKey={data.name.toLowerCase()} key={i} className="p-0">
                                                <div className="bg-white p-0">
                                                    {data.content}
                                                </div>
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Clean CSS without borders and gray colors */}
            <style jsx>{`
                .custom-tab-1 .nav-tabs {
                    border: none !important;
                }
                
                .custom-tab-1 .nav-tabs .nav-link {
                    border: none !important;
                    background: transparent !important;
                }
                
                .custom-tab-1 .nav-tabs .nav-link.active {
                    background-color: #fff !important;
                    border: none !important;
                    color: #007bff !important;
                    font-weight: 600;
                    border-bottom: 3px solid #007bff !important;
                }
                
                .custom-tab-1 .nav-tabs .nav-link:hover:not(.disabled) {
                    background-color: rgba(0,123,255,0.05) !important;
                    border: none !important;
                    color: #007bff;
                    transform: translateY(-2px);
                }
                
                .custom-tab-1 .nav-tabs .nav-link.disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
                
                .custom-tab-1 .tab-content {
                    border: none !important;
                }
                
                .provider-type-header {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border-radius: 8px 8px 0 0;
                }
                
                .provider-type-header h4 {
                    color: white;
                    font-weight: 600;
                }
                
                .provider-type-header p {
                    color: rgba(255, 255, 255, 0.8);
                }
                
                .provider-type-header .btn-outline-primary {
                    border-color: rgba(255, 255, 255, 0.5);
                    color: white;
                }
                
                .provider-type-header .btn-outline-primary:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: white;
                }
                
                .provider-type-header .btn-primary {
                    background-color: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.3);
                    color: white;
                }
                
                .provider-type-header .btn-primary:hover {
                    background-color: rgba(255, 255, 255, 0.3);
                    border-color: rgba(255, 255, 255, 0.5);
                }
            `}</style>
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        errorMessage: state.user.errorMessage,
        successMessage: state.user.successMessage,
        showLoading: state.user.showLoading,
        currentUser: currentUser(state) 
        //admin: state.admin.administration,
    };
};

export default connect(mapStateToProps)(UserProfil);